// frontend/src/services/api.js

// In produzione, l'API è disponibile sullo stesso dominio sotto /api
// In sviluppo, usa l'indirizzo locale
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

console.log('API URL configurato:', API_BASE_URL);

// Ottieni il token dal localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// Timeout più lungo per le richieste (30 secondi)
const fetchWithTimeout = async (url, options, timeout = 30000) => {
  console.log(`Richiesta a: ${url}`, options);
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      headers: {
        ...options.headers || {},
        ...getAuthHeaders(),
      },
    });
    
    console.log(`Risposta da: ${url}`, {
      status: response.status,
      ok: response.ok
    });
    
    if (!response.ok) {
      // Se otteniamo 401 Unauthorized, potrebbe essere scaduto il token
      if (response.status === 401) {
        localStorage.removeItem('authToken');
        // Questo forzerà il logout e il redirect al login nella prossima interazione
        window.location.reload();
      }
      
      throw new Error(`Errore HTTP: ${response.status}`);
    }
    
    const data = await response.json();
    console.log(`Dati ricevuti da: ${url}`, data);
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.error(`Timeout dopo ${timeout}ms per: ${url}`);
      throw new Error(`La richiesta è scaduta dopo ${timeout / 1000} secondi`);
    }
    console.error(`Errore durante la richiesta a: ${url}`, error);
    throw error;
  } finally {
    clearTimeout(id);
  }
};

/**
 * Crea una nuova chat
 * @returns {Promise<Object>} Dati della nuova chat
 */
export const createChat = async () => {
  console.log('Creazione nuova chat...');
  try {
    const data = await fetchWithTimeout(`${API_BASE_URL}/api/chats`, {
      method: 'POST'
    });
    console.log('Chat creata con successo:', data);
    return data;
  } catch (error) {
    console.error('Errore durante la creazione della chat:', error);
    throw error;
  }
};

/**
 * Ottieni chat esistente con tutti i messaggi
 * @param {number} chatId ID della chat da recuperare
 * @returns {Promise<Object>} Dati della chat con messaggi
 */
export const getChat = async (chatId) => {
  console.log(`Recupero chat con ID: ${chatId}...`);
  try {
    const data = await fetchWithTimeout(`${API_BASE_URL}/api/chats/${chatId}`, {
      method: 'GET'
    });
    console.log(`Chat ${chatId} recuperata con successo:`, data);
    return data;
  } catch (error) {
    console.error(`Errore durante il recupero della chat ${chatId}:`, error);
    throw error;
  }
};

/**
 * Invia un messaggio nella chat
 * @param {number} chatId ID della chat
 * @param {Object} message Oggetto contenente il messaggio da inviare
 * @returns {Promise<Array>} Array con messaggio utente e risposta assistant
 */
export const sendMessage = async (chatId, message) => {
  console.log(`Invio messaggio nella chat ${chatId}:`, message);
  try {
    const data = await fetchWithTimeout(`${API_BASE_URL}/api/chats/${chatId}/messages`, {
      method: 'POST',
      body: JSON.stringify(message),
    });
    console.log(`Messaggio inviato con successo, risposta:`, data);
    return data;
  } catch (error) {
    console.error(`Errore durante l'invio del messaggio nella chat ${chatId}:`, error);
    throw error;
  }
};